import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  apiKey: window.data.googleMapApiKey,
  version: "weekly",
});

loader.load().then(() => {
  const centerIndex = window.data.coordinates.findIndex((c) => c.hq);
  const center =
    window.data.coordinates[centerIndex] === -1 ? window.data.coordinates[0] : window.data.coordinates[centerIndex];
  const markers = {};
  const infoWindows = {};

  const map = new google.maps.Map(document.getElementById("map"), {
    center,
    disableDefaultUI: true,
    gestureHandling: "cooperative",
    zoom: 12,
  });

  function showDirectionInfoWindow(marker, url, name) {
    Object.values(infoWindows).forEach(function (infoWindow) {
      infoWindow.close();
    });

    infoWindows[name] =
      infoWindows[name] ??
      new google.maps.InfoWindow({
        content: `<a href="${url}" target="_blank" class="ch24-link">${django
          // eslint-disable-next-line quotes
          .gettext('Route zu "%s" berechnen')
          .replace("%s", name)}</a>`,
      });

    infoWindows[name].open({
      anchor: marker,
      map,
      shouldFocus: false,
    });
  }

  document
    .querySelectorAll(".ch24-location-officesAddress")
    .forEach(function (office) {
      office.addEventListener("click", function () {
        const officeCoordinatesIndex = window.data.coordinates.findIndex(
          (c) => c.name === office.dataset.officeId
        );

        if (officeCoordinatesIndex === -1) {
          return;
        }

        const { lat, lng, url, name } = window.data.coordinates[officeCoordinatesIndex];
        map.setCenter({ lat, lng });
        showDirectionInfoWindow(markers[office.dataset.officeId], url, name);
      });
    });

  window.data.coordinates.forEach(({ lat, lng, name, url }) => {
    const marker = new google.maps.Marker({
      position: { lat, lng },
      title: name,
      icon: "/static/svg/c24-map-marker.svg",
      map,
    });

    marker.addListener("click", () => {
      map.setCenter({ lat, lng });
      showDirectionInfoWindow(marker, url, name);
    });

    markers[name] = marker;
  });
});
